<template>
    <div>
        <div v-if="!Values || Values.length === 0" class="m-1">
            <b-icon 
                icon="check-circle-fill" 
                variant="success" 
                font-scale="1.5"/>
        </div>
        <b-button
            v-else
            :id="'error-trigger-' + Id"
            :variant="'outline-' + statusColor"
            size="sm"
            pill
            class="d-inline-flex align-items-center font-weight-bold m-1 shadow-sm">
            <b-icon :icon="statusIcon" class="mr-1" />
            <span>{{ Values.length }}</span>
            <b-icon icon="chevron-down" class="ml-1" font-scale="0.8" />
        </b-button>
        <b-popover 
            v-if="Values && Values.length > 0"
            :target="'error-trigger-' + Id" 
            triggers="click blur" 
            placement="bottom"
            custom-class="shadow">
            <template #title>
                {{ $t('ErrorsDetails') }}
            </template>
            <ul class="list-unstyled mb-0" style="max-width: 400px;">
                <li v-for="(error, index) in Values" 
                    :key="index" 
                    class="border-left border-dark pl-2 mb-1"
                    :title="error">
                    {{ error }}
                </li>
            </ul>
        </b-popover>
    </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, InjectReactive } from 'vue-property-decorator';
import locale from '../../locales/SMA.json';

@Component({
    i18n: { messages: locale }
})
export default class ErrorsCell extends Vue {

    /** Identifiant compteur (utilisé pour lier l'icône au popover) */
    @Prop({ default: () => '' }) 
    public Id!: string;

    /** Valeurs */
    @Prop({ default: () => [] })
    public Values!: string[];

    /** Variant de couleur par défaut */
    @InjectReactive()
    public Variant!: string;

    /**
     * Détermine la couleur du symbole selon les codes d'erreur (Bootstrap variants)
     */
    get statusColor(): string {
        if (!this.Values || this.Values.length === 0) {
            return 'success';
        }
        
        return 'danger';
    }

    /**
     * Détermine l'icône BootstrapVue à afficher
     */
    get statusIcon(): string {
        if (!this.Values || this.Values.length === 0) {
            return 'check-circle-fill'; // Check pour succès
        }
        return 'exclamation-circle-fill'; // Point d'exclamation pour erreur
    }
}
</script>

<style scoped>
.cursor-pointer {
    cursor: pointer;
}
</style>